import { IconChevronLeft } from "@tabler/icons-react";

export interface BackButtonProps {
  label: string;
  onClick: () => void;
}

const BackButton = ({
  label, onClick,
}: BackButtonProps) => (
  <div className="typography-small-base w-[374px] sm:w-[518px] md:w-[940px] px-4 sm:px-6 md:px-20">
    <button type="button" onClick={() => onClick()}>
      <div className="flex items-center">
        <IconChevronLeft className="text-icon-bg-subtle" />
        <span className="text-text-subtle">{label}</span>
      </div>
    </button>
  </div>
);

export default BackButton;
